import React from 'react'
import { connect } from 'react-redux'
import {
  Form,
  reduxForm,
  Field,
  change,
  submit,
  getFormValues
} from 'redux-form'
import { useHistory } from 'react-router-dom'
import { isEmpty } from 'lodash'

import heic2any from 'heic2any'
import {
  makeStyles,
  styled,
  Checkbox,
  CircularProgress,
  Backdrop
} from '@material-ui/core'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'

import {
  getUsers,
  getUserById,
  clearCurrentUser
} from '../../store/users/actions'
import { createDoorman } from '../../store/doormen/actions'

import {
  required,
  validEmail,
  capitalize,
  normalizePhone,
  normalizeCPF,
  validPhone,
  isValidCPF
} from '../../utils/formUtils'
import { occupationsIds, occupationsArray } from '../../utils/constants'
import InputSelect from '../select/InputSelect'
import { handleAddAvatar } from '../../utils/helpers'
import MaterialInput from '../shared/MaterialInput'
import StyledSVG from '../shared/StyledSVG'
import Button from '../button/Button'

import cameraSVG from '../../assets/icons/camera-icon.svg'
import emptyAvatar from '../../assets/icons/empty-avatar-icon.svg'

const useStyles = makeStyles(theme => ({
  form_class: {
    height: '100%'
  },
  root: {
    height: '85%'
  },
  main_content_wrapper: {
    marginTop: 56,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 56
  },
  form_section: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 24,
    '& h1.label': {
      color: '#386093',
      fontSize: 20,
      fontWeight: 600,
      margin: 0
    },
    '& p.sublabel': {
      margin: '16px 0px 0px 0px',
      fontWeight: 400,
      fontSize: 16
    }
  },
  user_form: {
    display: 'flex',
    columnGap: 32
  },
  registered_user_input: {
    width: '80%'
  },
  float_edit_avatar: {
    cursor: 'pointer',
    position: 'absolute',
    right: 0,
    bottom: 0,
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: '#F4A87C',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  float_remove_avatar: {
    cursor: 'pointer',
    position: 'absolute',
    right: 0,
    top: 0,
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: '#EF7C8FCC',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  remove_photo: {
    zIndex: 1,
    right: '-1px',
    top: '-1px',
    color: '#FFFFFF',
    margin: '5px'
  },
  photo_info: {
    fontWeight: 400,
    fontSize: 10,
    color: '#868E96'
  },
  photo_section: {
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  },
  photo_empty: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#D9D9D9',
    width: 140,
    height: 140,
    borderRadius: '50%',
    border: '1px dashed #868E96'
  },
  material_input_class: {
    width: '100%',
    height: 40,
    marginBottom: '0px !important',
    '& .MuiSelect-select.MuiSelect-select': {
      color: '#D2D5D8'
    }
  },
  fields_wrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
    columnGap: 16,
    rowGap: 24
  },
  search_field: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
    height: 'fit-content',
    '& p.label': {
      margin: 0,
      fontSize: 12,
      fontWeight: 600,
      color: '#555555'
    }
  },
  occupations_wrapper: {
    columnCount: 3
  },
  occupation_item: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 18,
    '& p.checkbox_label': {
      margin: 0,
      fontWeight: 400,
      fontSize: 16
    }
  },
  bottom_btns: {
    marginTop: 24,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    columnGap: 16,
    '& p.btn_child': {
      fontWeight: 600,
      fontSize: 16,
      margin: 0,
      textTransform: 'none'
    }
  },
  back_btn: {
    width: 144,
    border: '1px solid #EF7C8F',
    height: 44,
    padding: '14px 48px',
    gap: 10,
    color: '#EF7C8F',
    borderRadius: 8,
    '&:hover': {
      border: '1px solid #EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  create_btn: {
    backgroundColor: '#386093',
    height: 44,
    width: 220,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    lineHeight: '19.5px'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1
  },
  capitalizedInput: {
    '& .MuiInput-input': {
      textTransform: 'capitalize'
    }
  }
}))

const PhotoPreview = styled('div')(({ theme, bgImg }) => ({
  position: 'relative',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: 140,
  height: 140,
  borderRadius: '50%',
  backgroundImage: `url(${bgImg})`
}))

const FormFieldWrapper = styled('div')(({ theme, gridColumn }) => ({
  gridColumn: `span ${gridColumn || 6}`
}))

const CreateBtnLabel = ({ addOccupation, editDoorman }) => {
  if (addOccupation) {
    return <p>Adicionar ocupação</p>
  } else if (editDoorman) {
    return <p>Editar usuário</p>
  } else {
    return <p>Cadastrar usuário</p>
  }
}

const EditUserForm = ({
  getUsers,
  schoolId,
  fieldValues,
  change,
  defaultOccupation,
  registeredUserId,
  clearCurrentUser,
  getUserById,
  fetchedUser,
  handleSubmit,
  submit,
  isEdit,
  createdSuccess,
  redirectPath,
  valid
}) => {
  const classes = useStyles()
  const [openBackdrop, setOpenBackdrop] = React.useState(false)
  const [selectedUser, setSelectedUser] = React.useState([])
  const [avatarBlob, setAvatarBlob] = React.useState(null)
  const [selectedOccupations, setSelectedOccupations] = React.useState([
    ...(defaultOccupation ? [defaultOccupation] : [])
  ])
  const history = useHistory()
  const avatarRef = React.useRef(null)
  const hasAvatar = !!avatarBlob || !!fetchedUser?.currentUser.avatar_url

  React.useEffect(
    () => {
      if (createdSuccess) {
        history.push(redirectPath)
      }
    },
    [createdSuccess]
  )

  React.useEffect(
    () => {
      if (selectedUser.length > 0 || !!registeredUserId) {
        const userId = isEdit ? registeredUserId : selectedUser[0].id
        change('id', userId)
        getUserById({
          id: userId,
          params: { include: 'school_doormen,user_occupations' }
        })
      } else {
        change('id', null)
        clearCurrentUser()
      }
      return () => {
        clearCurrentUser()
      }
    },
    [selectedUser, registeredUserId]
  )

  React.useEffect(
    () => {
      if (!isEmpty(fetchedUser.currentUser)) {
        handleFillFormFields(fetchedUser.currentUser)
      } else {
        handleFillFormFields({})
      }
    },
    [fetchedUser.currentUser]
  )

  const handleToggle = () => {
    valid && setOpenBackdrop(!openBackdrop)
  }

  const handleFillFormFields = attributes => {
    change('name', attributes?.name)
    change('phone', attributes?.phone)
    change('email', attributes?.email)
    change('taxpayer_number', attributes?.taxpayer_number)
    change('avatar', attributes?.avatar_url)
    change('user_occupations', attributes?.user_occupations)
    change('school_doormen', attributes?.school_doormen)
  }

  const handleOnChangeAvatar = event => {
    handleAddAvatar(
      event,
      null,
      alert,
      param =>
        setAvatarBlob(prevState => {
          change('avatar', param)
          return param
        }),
      heic2any
    )
  }

  const handleDeleteAvatar = () => {
    setAvatarBlob(null)
    change('avatar', 'delete')
  }

  const handleCheck = id => {
    setSelectedOccupations(prev => {
      const newData = prev.includes(id)
        ? prev.filter(item => item !== id)
        : [...prev, id]
      return newData
    })
  }

  if (fetchedUser?.isFetching) {
    return <CircularProgress />
  }
  return (
    <div className={classes.root}>
      <Form className={classes.form_class} onSubmit={handleSubmit}>
        {!registeredUserId && (
          <InputSelect
            wrapperClass={classes.registered_user_input}
            selectedItems={selectedUser}
            setSelectedItems={setSelectedUser}
            fetchItems={getUsers}
            placeholder={'Digite o nome do usuário ja cadastrado'}
            label={'Buscar usuário'}
            params={{
              schoolId,
              'page[size]': 7
            }}
          />
        )}
        <div className={classes.main_content_wrapper}>
          <div className={classes.form_section}>
            <h1 className='label'>Dados pessoais</h1>
            <div className={classes.user_form}>
              {hasAvatar && fieldValues?.avatar !== 'delete' ? (
                <div className={classes.photo_section}>
                  {!avatarBlob ? (
                    <PhotoPreview bgImg={fetchedUser?.currentUser?.avatar_url}>
                      <div
                        onClick={() =>
                          avatarRef.current && avatarRef.current.click()
                        }
                        className={classes.float_edit_avatar}
                      >
                        <StyledSVG src={cameraSVG} width={20} height={20} />
                      </div>
                      <div className={classes.float_remove_avatar}>
                        <HighlightOffIcon
                          className={classes.remove_photo}
                          onClick={() => handleDeleteAvatar()}
                        />
                      </div>
                    </PhotoPreview>
                  ) : (
                    <PhotoPreview bgImg={URL.createObjectURL(avatarBlob)}>
                      <div
                        onClick={() =>
                          avatarRef.current && avatarRef.current.click()
                        }
                        className={classes.float_edit_avatar}
                      >
                        <StyledSVG src={cameraSVG} width={20} height={20} />
                      </div>
                      <div className={classes.float_remove_avatar}>
                        <HighlightOffIcon
                          className={classes.remove_photo}
                          onClick={() => handleDeleteAvatar()}
                        />
                      </div>
                    </PhotoPreview>
                  )}
                  <span className={classes.photo_info}>
                    Min. 200x200 px.<br />.png, .jpg, .jpeg ou .heic
                  </span>
                </div>
              ) : (
                <div className={classes.photo_section}>
                  <PhotoPreview bgImg={emptyAvatar}>
                    <div
                      onClick={() =>
                        avatarRef.current && avatarRef.current.click()
                      }
                      className={classes.float_edit_avatar}
                    >
                      <StyledSVG src={cameraSVG} width={20} height={20} />
                    </div>
                  </PhotoPreview>
                  <span className={classes.photo_info}>
                    Min. 200x200 px.<br />.png, .jpg, .jpeg ou .heic
                  </span>
                </div>
              )}
              <input
                accept='.png, .jpg, .jpeg, .heic'
                hidden
                name='avatar'
                onChange={handleOnChangeAvatar}
                ref={avatarRef}
                type='file'
              />
              <div className={classes.fields_wrapper}>
                <FormFieldWrapper
                  gridColumn={12}
                  className={`${classes.search_field}`}
                >
                  <p className='label'>Nome completo</p>
                  <Field
                    rootClass={`${classes.material_input_class} ${
                      classes.capitalizedInput
                    }`}
                    component={MaterialInput}
                    name='name'
                    placeholder='Digite o nome completo'
                    type='text'
                    autoComplete='off'
                    validate={[required]}
                  />
                </FormFieldWrapper>
                <FormFieldWrapper
                  gridColumn={6}
                  className={`${classes.search_field}`}
                >
                  <p className='label'>Email</p>
                  <Field
                    rootClass={classes.material_input_class}
                    component={MaterialInput}
                    name='email'
                    placeholder='Digite o email'
                    type='email'
                    autoComplete='off'
                    validate={[required, validEmail]}
                  />
                </FormFieldWrapper>
                <FormFieldWrapper
                  gridColumn={3}
                  className={`${classes.search_field}`}
                >
                  <p className='label'>CPF</p>
                  <Field
                    allowClear
                    rootClass={classes.material_input_class}
                    component={MaterialInput}
                    name={`taxpayer_number`}
                    placeholder='CPF'
                    type='text'
                    autoComplete='off'
                    normalize={normalizeCPF}
                    validate={[required, isValidCPF]}
                  />
                </FormFieldWrapper>
                <FormFieldWrapper
                  gridColumn={3}
                  className={`${classes.search_field}`}
                >
                  <p className='label'>Telefone</p>
                  <Field
                    rootClass={classes.material_input_class}
                    component={MaterialInput}
                    name='phone'
                    placeholder='Ex:(61) 99999-9999'
                    type='text'
                    autoComplete='off'
                    normalize={normalizePhone}
                    validate={[required, validPhone]}
                  />
                </FormFieldWrapper>
              </div>
            </div>
          </div>
          {!defaultOccupation && (
            <div className={classes.form_section}>
              <div>
                <h1 className='label'>Ocupações do usuário</h1>
                <p className='sublabel'>
                  Selecione uma ou mais funções exercidas pelo usuário na
                  escola.
                </p>
              </div>
              <div className={classes.occupations_wrapper}>
                {occupationsArray.filter(item => item[0] !== 1).map(item => {
                  const checked = selectedOccupations.find(
                    ocp => item[0] === ocp
                  )
                  const disabled =
                    item[0] === 2 || item[0] !== defaultOccupation
                  return (
                    <div key={item[0]} className={classes.occupation_item}>
                      <Checkbox
                        value={item[0]}
                        className={classes.check}
                        checked={checked}
                        disabled={disabled}
                        disableRipple={disabled}
                        onChange={() => handleCheck(item[0])}
                        color='primary'
                      />
                      <p className='checkbox_label'>{item[1]}</p>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
          <div className={classes.bottom_btns}>
            <Button
              className={classes.back_btn}
              variant='outlined'
              type='button'
              onClick={() => history.push('/settings/doorman')}
            >
              Cancelar
            </Button>
            <Button
              disabled={!valid}
              className={classes.create_btn}
              type='submit'
              onClick={handleToggle}
            >
              <CreateBtnLabel
                addOccupation={selectedUser.length > 0}
                editDoorman={!!registeredUserId}
                className='btn_child'
              />
            </Button>
          </div>
        </div>
      </Form>
      <Backdrop className={classes.backdrop} open={openBackdrop}>
        <CircularProgress color='secondary' />
      </Backdrop>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  const { auth, school, users } = state
  return {
    fieldValues: getFormValues('editUserForm')(state),
    userOccupations: auth.currentOccupation,
    currentSchool: school.currentSchool.school,
    fetchedUser: users
  }
}

const mapDispatchToProps = dispatch => ({
  getUsers: data => dispatch(getUsers.request(data)),
  change: (field, data) => dispatch(change('editUserForm', field, data)),
  submit: () => dispatch(submit('editUserForm')),
  getUserById: data => dispatch(getUserById(data)),
  clearCurrentUser: () => dispatch(clearCurrentUser()),
  createDoorman: data => dispatch(createDoorman(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'editUserForm',
    enableReinitialize: true,
    onSubmit: async (values, dispatch, props) => {
      const { createDoorman } = props
      const school_id = props.currentSchool.id
      const school_doorman = props?.fetchedUser?.currentUser?.school_doormen?.find(
        item => +item.school_id === +school_id
      )
      const doorman_occupation = props?.fetchedUser?.currentUser?.user_occupations?.find(
        item => +item.occupation_id === +occupationsIds['DOORMAN']
      )
      const userData = {
        id: values?.id,
        name: capitalize(values?.name),
        taxpayer_number: values?.taxpayer_number,
        email: values?.email,
        phone: values?.phone,
        school_id,
        ...(values?.avatar ? { avatar: values.avatar } : {}),
        has_school_doorman: !!school_doorman,
        has_doorman_occupation: !!doorman_occupation
      }
      createDoorman(userData)
    }
  })(EditUserForm)
)
